import React from 'react';
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Accordion, AccordionItem, AccordionItemTitle, AccordionItemBody } from 'react-accessible-accordion';

import { MdAdd } from 'react-icons/md';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import CallToAction from '../components/CallToAction';

const ServicePage = ({ data }) => (
  <Layout>
    <SEO
      meta_title={data.prismicService.data.meta_title}
      meta_description={data.prismicService.data.meta_description}
      hero_image={data.prismicService.data.hero_image.url}
    />
    <Hero
      title={
        <div
          dangerouslySetInnerHTML={{
            __html: data.prismicService.data.hero_text.html,
          }}
        />
      }
      overlay="bg-black opacity-50"
      imagebg={data.prismicService.data.hero_image.localFile.childImageSharp.fluid}
    />
    <section>
      <div className="container">
        <div className="flex flex-wrap">
          <div className="w-full mb-4">
            <p className="uppercase text-xs text-grey-dark">
              <Link to="services" className="no-underline">
                Services
              </Link>{' '}
              / {data.prismicService.data.title.text}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap md:-mx-6 justify-center">
          <div className="w-full md:w-1/2 md:px-6">
            <div
              dangerouslySetInnerHTML={{
                __html: data.prismicService.data.content.html,
              }}
            />
          </div>

          <div className="w-full md:w-1/2 md:px-6 mb-6">
            <Img fluid={data.prismicService.data.service_image.localFile.childImageSharp.fluid} />
          </div>
        </div>

        <div className="flex flex-wrap">
          <div className="w-full">
            <Accordion>
              {data.prismicService.data.accordion.map(({ accordion_title, accordion_content }) => (
                <AccordionItem key={accordion_title.text}>
                  <AccordionItemTitle>
                    <h4 className="mb-0">{accordion_title.text}</h4>
                    <MdAdd />
                  </AccordionItemTitle>
                  <AccordionItemBody>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: accordion_content.html,
                      }}
                    />
                  </AccordionItemBody>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>

    <CallToAction />
  </Layout>
);

export default ServicePage;

export const pageQuery = graphql`
  query PostBySlug($uid: String!) {
    prismicService(uid: { eq: $uid }) {
      uid
      data {
        meta_title
        meta_description
        service_type
        title {
          text
        }
        content {
          html
          text
        }
        accordion {
          accordion_title {
            text
          }
          accordion_content {
            html
          }
        }
        hero_image {
          url
          localFile {
            childImageSharp {
              fluid(maxWidth: 1600, maxHeight: 1000, quality: 80, cropFocus: CENTER) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        service_image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 800, maxHeight: 800, quality: 80, cropFocus: CENTER) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        hero_text {
          html
        }
      }
    }
    mitigationTag: prismicTags(data: { tag: { text: { eq: "Mitigation and Emergency Services" } } }) {
      id
      data {
        tag {
          text
        }
      }
    }
    remodelingTag: prismicTags(data: { tag: { text: { eq: "Remodeling and Construction Services" } } }) {
      id
      data {
        tag {
          text
        }
      }
    }
  }
`;
